import { EventEmitter } from '@angular/core';
import { PathHelper } from 'src/app/helpers/path.helper';

export class ExplorerManager {
  private current: string = null;

  changeEvent = new EventEmitter<any>();

  get cwd() {
    return this.current;
  }

  set cwd(v) {
    this.current = v;
    this.changeEvent.emit();
  }

  navigateTo(directory: string) {
    if (directory && (directory[0] === "/" || directory.includes(":/"))) {
      this.cwd = directory;
    }
    else {
      this.cwd = PathHelper.join(this.cwd, directory);
    }
  }
}
